module.exports = __webpack_public_path__ + "static/app-shot-1-3-3881666ee5a536130b1016e15a7f28f7.jpg";